var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        { name: "show", rawName: "v-show", value: _vm.show, expression: "show" }
      ],
      staticClass: "lite_popup"
    },
    [
      _c("div", { staticClass: "lite_popup_box lite_popup_box_confirm" }, [
        _c("div", { staticClass: "lite_popup_title" }, [
          _c("span", [_vm._v(_vm._s(_vm.data.title))]),
          _vm._v(" "),
          _c("div", {
            staticClass: "icon white-close dialog-close",
            on: {
              click: function($event) {
                _vm.show = false
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "lite_popup_content" }, [
          _c("div", [_vm._v(_vm._s(_vm.data.desc))])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "lite_popup_footer" }, [
          _c(
            "button",
            {
              ref: "okBtn",
              on: {
                keyup: [
                  function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "esc", 27, $event.key, [
                        "Esc",
                        "Escape"
                      ])
                    ) {
                      return null
                    }
                    _vm.show = false
                  },
                  function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.ok($event)
                  }
                ],
                click: _vm.ok
              }
            },
            [_vm._v(_vm._s(_vm.$t("language.common.ok")))]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-957c660e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-957c660e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/lite_confirm.vue
// module id = null
// module chunks = 